import React from "react";

function LogoutConfirmationModal({ open, onClose, onConfirm, loading, error }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 relative animate-fade-in">
        <div className="flex flex-col items-center text-center text-red-700">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={75}
            height={75}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16,17 21,12 16,7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <h2 className="text-xl font-bold text-red-700 mb-2">
            Confirm Logout
          </h2>
          <p className="text-gray-700 mb-4">
            Are you sure you want to{" "}
            <span className="font-bold text-red-600">logout</span> from your
            account?
            <br />
            You will need to sign in again to access your account.
          </p>
          <div className="flex gap-4 w-full mt-2">
            <button
              onClick={onConfirm}
              disabled={loading}
              className="flex-1 bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-md transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {loading ? "Logging out..." : "Logout"}
            </button>
            <button
              onClick={onClose}
              disabled={loading}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-md transition-colors"
            >
              Cancel
            </button>
          </div>
          {error && <div className="mt-4 text-red-600 text-sm">{error}</div>}
        </div>
      </div>
    </div>
  );
}

export default LogoutConfirmationModal;
